/* eslint-disable no-useless-escape */
/* eslint-disable no-shadow */
import React, {
  useEffect,
} from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { businessActions, customDocumentRequestActions, notificationActions } from 'store/actions';
import Loading from 'components/Loading';
import VerificationProcess from './components/VerificationProcess';
import VerifiedDetails from './components/VerifiedDetails';
import RequiredDocumentsUpload from './components/RequiredDocumentsUpload';

type Props = {
  selectedAccount: Object,
  fetchPaypalVerification: Function,
  paypalVerification: Object,
  fetchPaypalRequiredDocuments: Function,
  fetchCustomDocumentRequest: Function,
  loading: Boolean,
};

const Paypal = (props: Props) => {
  const {
    selectedAccount,
    fetchPaypalVerification,
    paypalVerification,
    fetchPaypalRequiredDocuments,
    fetchCustomDocumentRequest,
    loading,
  } = props;

  const debouncedFetchDocuments = debounce(fetchCustomDocumentRequest, 2000, { leading: true });

  useEffect(() => {
    if (selectedAccount && selectedAccount?.gid) {
      fetchPaypalVerification(selectedAccount?.gid);
    }
  }, [selectedAccount?.gid]);

  const getData = () => {
    const currentPage = 1;
    const sortBy = 'updatedAt';
    const direction = 'DESC';
    const sortParams = `&sortBy=${sortBy}&direction=${direction}`;
    const filterParams = 'type.EQ=PAYPAL_VERIFICATION';
    debouncedFetchDocuments({ currentPage, sortParams, filterParams });
    fetchPaypalRequiredDocuments();
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      {!paypalVerification?.paypalStatus ? (
        <VerificationProcess />
      ) : <VerifiedDetails selectedAccount={selectedAccount} verificationDetails={paypalVerification} />}
      <RequiredDocumentsUpload />
    </div>
  );
};

const mapStateToProps = state => ({
  selectedAccount: state.account.selectedAccount,
  test: state.account.test,
  isSuperUser: state.user.superUser,
  loading: state.loading.loading,
  validator: state.loading.validator,
  paypalVerification: state.business.paypalVerification,
  paypalRequiredDocuments: state.business.paypalRequiredDocuments,
  submitting: state.loading.submitting,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  fetchPaypalVerification: gid => dispatch(businessActions.fetchPaypalVerification({
    payload: gid,
  })),
  fetchPaypalRequiredDocuments: () => dispatch(businessActions.fetchPaypalRequiredDocuments()),
  fetchCustomDocumentRequest: param => dispatch(customDocumentRequestActions.fetchCustomDocumentRequest({
    payload: param,
  })),
});

// $FlowFixMe
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Paypal);
